import { array, dateTime, defineAction, number, object, string } from '~/prix'
import agentRequestListAction from './agentRequestList.action.json'

const agentRequestListDefinition = defineAction({
  ...agentRequestListAction,
  input: object({
    agentCpf: string(),
  }),
  output: object({
    requests: array(
      object({
        entrepreneurCpf: string(),
        status: string(),
        latitude: number(),
        longitude: number(),
        accuracy: number(),
        street: string().isOptional(),
        approximateNumber: number().isOptional(),
        neighborhood: string().isOptional(),
        city: string(),
        cityIbge: number(),
        stateAbbreviation: string(),
        lastGeolocationUpdate: dateTime(),
        geodesicDistanceMeters: number(),
        drivingDistanceMeters: number(),

        legalEntityCnpj: string().isOptional(),
        corporateName: string().isOptional(),
        tradeName: string().isOptional(),
        economicActivity: string().isOptional(),
        sizeAbbreviature: string().isOptional(),
      }),
    ),
  }),
})

export default agentRequestListDefinition
